module.exports = __webpack_public_path__ + "img/OverseaMember06.09db228f.jpg";